import React, { useEffect } from 'react';
import { notifyParent } from 'src/utils/notifyIframe';

let hasCalled = false;
export function ReadyStateChangeMarker() {
  useEffect(() => {
    if (!hasCalled) notifyParent({ type: 'survey_iframe_readystatechange', state: 'ready' });
    hasCalled = true;
  });
  return <div id="readystatechange" style={{ display: 'none' }} />;
}
